import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  RequestQuotationClientRequest,
  RequestQuotationClientResponse,
} from '../../../@types/RequestQuotation'
import { ENV } from '../../../Environment'
import { api } from '../../../Services/API'
import { useRequestQuotationStore } from '../../../Stores/useRequestQuotationStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { useErrorRequest } from '../../useErrorRequest'

const headers = {
  'aip-language': ENV().RequestQuotation.Language,
  'aip-company': ENV().RequestQuotation.Company,
}

const request = async (payload: RequestQuotationClientRequest) => {
  const response = await api.post<RequestQuotationClientResponse>(
    API_ROUTES.requestQuotation,
    payload,
    { headers },
  )

  return response.data
}

export const useRequestQuotation = () => {
  const { handleErrorRequest } = useErrorRequest()
  const { setRequestQuotation } = useRequestQuotationStore()

  return useMutation({
    mutationFn: (payload: RequestQuotationClientRequest) => request(payload!),
    onSuccess(data) {
      setRequestQuotation(data)
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
